import { FilterViewModel } from "../regulation";
import { userDropdownDto } from "./SelfAssessmentInterpretation";

export class overallAssessmentDropdownList {
  assessorName: userDropdownDto[];
  assessmentCategory: string[];
  assessmentStatus: string[];
  complianceStatus: string[];
  reviewStatus: string[];
  reviewerName: userDropdownDto[];
  actionOwner: userDropdownDto[];
  actionTypeList: string[];
  impactedBuisnessAreaList!: string[];
  lbgList: string[];
  rfbList: string[];
  lbcmList: string[];
  assessorTeamList: string[];
  actionClosedList: string[];
  topicList: string[];
  implementationStatusList: string[];
  lbgMaterialityList: string[];
  rfbMaterialityList: string[];
  lbcmMaterialityList: string[];
  submitterNameList: userDropdownDto[];
  natureReviewList: string[];
  reviewOutcomeList: string[];
  approversList: userDropdownDto[];
  constructor() {
    this.assessorName = [];
    this.assessmentCategory = [];
    this.assessmentStatus = [];
    this.complianceStatus = [];
    this.reviewStatus = [];
    this.reviewerName = [];
    this.actionOwner = [];
    this.actionTypeList = [];
    this.impactedBuisnessAreaList = [];
    this.lbgList = [];
    this.rfbList = [];
    this.lbcmList = [];
    this.assessorTeamList = [];
    this.actionClosedList = [];
    this.topicList = [];
    this.implementationStatusList = [];
    this.lbgMaterialityList = [];
    this.rfbMaterialityList = [];
    this.lbcmMaterialityList = [];
    this.submitterNameList = [];
    this.natureReviewList = [];
    this.reviewOutcomeList = [];
    this.approversList = [];
  }
}
export interface SelfAssessmentT3AllFilterDropdownDto {
  ruleOwner: FilterViewModel[];
  assessmentStatus: string[];
  complianceStatus: string[];
  lbgList: string[];
  rfbList: string[];
  lbcmList: string[];
  fromDate: string;
}
